// Promoção de quem assina pelo celular (AC-253): a tela de planos mostra o selo e a 1ª cobrança com
// desconto só no celular, só para quem nunca assinou e só quando o servidor informa a porcentagem
// do cupom (Pricing.mobileOffer). Quem aplica o desconto de verdade é o servidor (AC-254), com a
// mesma regra de celular de supabase/functions/_shared/mobileOffer.ts.

const MOBILE_UA = /Android|iPhone|iPad|iPod|Mobile/i;

export function isMobileUserAgent(ua: string | null | undefined): boolean {
  return !!ua && MOBILE_UA.test(ua);
}

/** Porcentagem que vale para esta pessoa, ou 0 quando a promoção não se aplica. */
export function mobileOfferFor(percent: number | undefined, ua: string | null | undefined, neverSubscribed: boolean): number {
  return percent && neverSubscribed && isMobileUserAgent(ua) ? percent : 0;
}

/** Valor da 1ª cobrança com o desconto, arredondado como o Stripe (centavos). */
export function discountedPrice(amount: number, percent: number): number {
  return Math.round(amount * (100 - percent)) / 100;
}
